import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Alert, Button, message, Result, Tag, Typography } from "antd";
import { BrowserView, isMobile } from "react-device-detect";
import Iframe from "react-iframe";
import Cookies from "universal-cookie";

import "./alipay.scss";
import {
  alipay_payment_url,
  alipay_qr,
  alipay_qr_status,
} from "../../apis/paymentGateway";
import { getTokenHeader, replaceUrlByParams } from "../../utils/api";
import { PAGE } from "../../utils/constants";
import { AppContext } from "../../App";

function AlipayPage() {
  let history = useHistory();
  const { pid } = useParams();
  const [url, setUrl] = useState("");
  const { appSetting, setLoading } = useContext(AppContext);
  const { Text } = Typography;
  const [paymentStatus, setPaymentStatus] = useState("pending");
  const { userToken } = getTokenHeader();
  const cookies = new Cookies();
  let interval;

  useEffect(() => {
    interval = setInterval(() => {
      checkPaymentStatus();
    }, 1500);

    if (paymentStatus === "pending") {
      if (isMobile) {
        getPaymentUrl();
      } else {
        getAlipayQR();
      }
    } else {
      history.replace(
        replaceUrlByParams(PAGE.APPLICATION_RESULT, { ":pid": pid })
      );
    }

    return () => clearInterval(interval);
  }, [paymentStatus]);

  const checkPaymentStatus = async () => {
    try {
      const res = await alipay_qr_status();
      if (res.error) {
        clearInterval(interval);
        message.error("操作無效，重新定向", 1, () => history.goBack());
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setPaymentStatus(res.payment.status);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const getAlipayQR = async () => {
    setLoading(true);
    try {
      const res = await alipay_qr();
      if (res.error) {
        clearInterval(interval);
        message.error("操作無效，重新定向", 1, () => history.goBack());
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setUrl(res.alipay.url);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  };

  const getPaymentUrl = async () => {
    cookies.set("userToken", userToken);
    // console.log(userToken, cookies.get('userToken'))
    try {
      const res = await alipay_payment_url(
        `${window.location.origin}/enrolment/#${replaceUrlByParams(
          PAGE.APPLICATION_RESULT,
          {
            ":pid": pid,
          }
        )}`
      );
      if (res.error) {
        clearInterval(interval);
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        window.location.assign(res.alipay.url);
      }
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      {paymentStatus === "pending" && (
        // <BrowserView>
        <Result
          className="alipay"
          icon={
            <Iframe
              url={url}
              width="200px"
              height="200px"
              id="aliqr"
              display="initial"
              frameBorder="0"
              scrolling="no"
            />
          }
          title="請使用AlipayHK「掃一掃」上方的二維碼付款"
          extra={
            <Button
              type="primary"
              onClick={() => {
                history.push(
                  `${replaceUrlByParams(PAGE.APPLICATION_RESULT, {
                    ":pid": pid,
                  })}`
                );
              }}
            >
              完成付款並返回
            </Button>
          }
        >
          <div className="title">
            或 經<a onClick={getPaymentUrl}>網頁登入</a>
          </div>
          <Text>
            *閣下可隨時於課程主頁<Tag>{appSetting.checkResultButton}</Tag>
            <span>以</span>
            {appSetting.checkResultForm.map((field, i) => {
              return <Tag key={i}>{field.name}</Tag>;
            })}
            登入付款
          </Text>
          <div style={{ marginTop: "16px" }}>
            <Alert
              message="繳費狀態更新需要數個工作天。請留意你是否已繳費，以免重覆付款。如有問題請聯絡我們"
              type="error"
            />
          </div>
        </Result>
        // </BrowserView>
      )}
    </>
  );
}

export default AlipayPage;
